export const Active_List = "Active_List";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const EDIT_USER = "EDIT_USER";
